const selector = (state) => state.admin;

export default selector;
